import { address as mezoMainnetAddress } from "@mezo-org/mezod-contracts/deployments/mainnet/mDAI.json"
import { address as mezoTestnetAddress } from "@mezo-org/mezod-contracts/deployments/testnet/mDAI.json"
import { Address } from "viem"

import artifacts from "#/shared/utils/artifacts"

export default artifacts.getBridgeableERC20TokenArtifact({
  mainnetAddress: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
  testnetAddress: "0x20fAeA18B6a1D0FCDBCcFfFe3d164314744baF30",
  mezoTestnetAddress: mezoTestnetAddress as Address,
  mezoMainnetAddress: mezoMainnetAddress as Address,
})
